import styled from 'styled-components';
import { T3 } from 'ia-react-core';

export const StyledDiv = styled.div`
  padding-top: 12px;
  text-align: center;
`;

export const StyledMessagesIcon = styled.svg`
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.blue6};
  padding: 10px 1px 10px 1px;
`;

export const StyledT3 = styled(T3)`
  margin-bottom: 12px;
`;
